export default {
  Error: 'Error',
  FormValidationError: 'FormValidationError',
  LoadModal: 'LoadModal',
  ExternalHpaRedirectResponse: 'ExternalHpaRedirectResponse',
  ClientRedirect: 'ClientRedirect',
};



// WEBPACK FOOTER //
// ./src/onePageGiving/SubmitResponseTypes.js